"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AbsenceTypesSearch;
const react_1 = __importStar(require("react"));
const FilterableTable_1 = __importDefault(require("../../View/Resultsets/FilterableTable/FilterableTable"));
const AbsenceTypeModalButtons_1 = require("./Modals/AbsenceTypeModalButtons");
const AbsenceTypesController_1 = require("./AbsenceTypesController");
const AbsenceTypeFilterBody_1 = require("./AbsenceTypeFilterBody");
const adminTableCells_1 = require("../adminTableCells");
const absenceTypePool_1 = require("./absenceTypePool");
/**
 * Lista typów nieobecności.
 *
 * Kolumna „Użyć” pokazuje, ile nieobecności korzysta z danego typu - typu
 * używanego w historii nie da się usunąć (blokuje to klucz obcy w bazie).
 *
 * UWAGA na sumę colMd: FilterableTableRow dokłada menu akcji jako osobną kolumnę
 * `xs="1"` POZA tableStructure, więc suma szerokości tutaj musi zostać najwyżej 11.
 * Dziś jest równo 11 (3 + 2 + 3 + 2 + 1) - kolejna kolumna wymaga zwężenia którejś z tych.
 */
function AbsenceTypesSearch({ title }) {
    (0, react_1.useEffect)(() => {
        document.title = title;
    }, [title]);
    return (react_1.default.createElement(FilterableTable_1.default, { id: "absenceTypes", title: title, FilterBodyComponent: AbsenceTypeFilterBody_1.AbsenceTypesFilterBody, tableStructure: [
            {
                header: "Nazwa",
                renderTdBody: (type) => react_1.default.createElement(adminTableCells_1.TextCell, { value: type.name }),
                colMd: 3,
            },
            {
                header: "Kolor",
                renderTdBody: (type) => react_1.default.createElement(adminTableCells_1.ColorCell, { value: type.color }),
                colMd: 2,
            },
            {
                header: "Schodzi z puli",
                renderTdBody: (type) => react_1.default.createElement(adminTableCells_1.TextCell, { value: (0, absenceTypePool_1.poolLabel)(type) }),
                colMd: 3,
            },
            {
                header: "Na godziny",
                renderTdBody: (type) => react_1.default.createElement(adminTableCells_1.BoolCell, { value: type.allowsPartialDay }),
                colMd: 2,
            },
            {
                header: "Użyć",
                renderTdBody: (type) => react_1.default.createElement(adminTableCells_1.TextCell, { value: type._usageCount ?? 0 }),
                colMd: 1,
            },
        ], AddNewButtonComponents: [AbsenceTypeModalButtons_1.AbsenceTypeAddNewModalButton], EditButtonComponent: AbsenceTypeModalButtons_1.AbsenceTypeEditModalButton, isDeletable: true, repository: AbsenceTypesController_1.absenceTypesRepository, searchOnMount: true }));
}
